export const loginRequest = () => ({
    type: 'LOGIN_REQUEST',
  });
  
  export const loginSuccess = (user) => ({
    type: 'LOGIN_SUCCESS',
    payload: user,
  });
  
  export const loginFailure = (error) => ({
    type: 'LOGIN_FAILURE',
    payload: error,
  });
  

  export const logout = () => ({
    type: 'LOGOUT',
  });
  export const historyData = (entityData) => ({
    type: 'HISTORY_DATA',
    payload: entityData,
  });
  export const ChangesLogDATA = (entityData) => ({
    type: 'Changes_Log_DATA',
    payload: entityData,
  });
  export const VendorRatingDetails = (entityData) => ({
    type: 'Vendor_Rating_Details',
    payload: entityData,
  });

  export const selectedSingleRow = (row) => ({
    type: 'SELECTED_ROW',
    payload: row,
  });

  export const PaymentDetailsViewDATA = (entityData) => ({
    type: 'payment_Details_View_DATA',
    payload: entityData,
  });
  export const OutstandingViewDATA = (entityData) => ({
    type: 'outstanding_View_DATA',
    payload: entityData,
  });